import { Component, OnInit, ElementRef, Renderer2, Output, EventEmitter } from '@angular/core';
import { DashboardService } from '@teem/services/dashboard.service';
import { dashboard as DashboardApi } from "@teem/constants/api";
import { environment } from '@teem/environments/environment';
import { LoaderService } from '@teem/services/loader.service';
import { InvoiceService } from '@teem/services/invoice.service';
import { ACTIONS as INVOICE_ACTIONS } from '@teem/constants/invoice';
import Swal from 'sweetalert2';
import { messages as i18n } from '@teem/constants/messages';

@Component({
	selector: 'app-invoice',
	templateUrl: './invoice.component.html',
	styleUrls: ['./invoice.component.scss']
})
export class InvoiceComponent implements OnInit {
	@Output() orderAction: EventEmitter<any> = new EventEmitter();
	isMenuUpwards = false;
	selectAllPendingInvoices: boolean = false;
	selectedCheckboxIds = [];
	pendingInvoices = [];

	constructor(
		private dashboardService: DashboardService,
		private renderer: Renderer2,
		private el: ElementRef,
		private loaderService: LoaderService,
		private invoiceService: InvoiceService,

	) {
		document.addEventListener('click', (event: Event) => {
			this.pendingInvoices.forEach((r) => (r.menuVisible = false));

			const targetElement = event.target as HTMLElement;

			if (!targetElement.closest('.dots_container-rounded')) {
				this.pendingInvoices.forEach((r) => (r.menuVisible = false));

				const optionsMenus = this.el.nativeElement.querySelectorAll('.options-menu');
				optionsMenus.forEach((menu: HTMLElement) => {
					this.renderer.addClass(menu, 'd-none');
				});
			}
		});
	}


	ngOnInit(): void {
		this.getPendingInvoices();
	}

	getPendingInvoices() {
		this.dashboardService.getPendingInvoice().subscribe((response: any = []) => {
			this.pendingInvoices = response;
		});
	}

	toggleMenu(event: MouseEvent, row: any, index: number): void {
		event.stopPropagation();
		
		// Scroll the table wrapper down slightly so the menu is visible (match behavior in CurrentOrders)
		const scrollContainer = (event.target as HTMLElement).closest('.table_wrapper');
		if (scrollContainer) {
			scrollContainer.scrollTop += 125;
		}

		this.pendingInvoices.forEach((r, i) => {
			if (i !== index) {
				r.menuVisible = false;
			}
		});
		row.menuVisible = !row.menuVisible;

		const totalRows = this.pendingInvoices.length;
		this.isMenuUpwards = index >= totalRows - 2;
	}

	toggleAllSelections(invoices: any[], selectAllVar: string) {
		this[selectAllVar] = !this[selectAllVar];
		invoices.forEach(invoice => invoice.selected = this[selectAllVar]);
	}

	toggleSelection(invoices: any[], selectAllVar: string) {
		this[selectAllVar] = invoices.every(invoice => invoice.selected);
	}

	toggleDropdown(event: Event): void {
		const button = event.target as HTMLElement;
		const dropdownContainer = button.closest('.custom_select');
		const dropdownMenu = dropdownContainer.querySelector('.custom_select-content');
		const allDropdowns = document.querySelectorAll('.custom_select-content');
		const allContainers = document.querySelectorAll('.custom_select');

		allDropdowns.forEach((dropdown) => {
			if (dropdown !== dropdownMenu) {
				this.renderer.setStyle(dropdown, 'display', 'none');
			}
		});

		allContainers.forEach((container) => {
			if (container !== dropdownContainer) {
				this.renderer.removeClass(container, 'active');
			}
		});

		const isDropdownVisible = dropdownMenu.getAttribute('style') === 'display: block;';

		this.renderer.setStyle(dropdownMenu, 'display', isDropdownVisible ? 'none' : 'block');

		if (isDropdownVisible) {
			this.renderer.removeClass(dropdownContainer, 'active');
		} else {
			this.renderer.addClass(dropdownContainer, 'active');
		}
	}

	onCheckChange(event: any, checkboxId: string) {
		if (event.target.checked) {
			// Add the checkbox ID to the array if checked
			this.selectedCheckboxIds.push(checkboxId);
		} else {
			// Remove the checkbox ID from the array if unchecked
			const index = this.selectedCheckboxIds.indexOf(checkboxId);
			if (index > -1) {
				this.selectedCheckboxIds.splice(index, 1);
			}
		}
		console.log(this.selectedCheckboxIds);
	}

	downloadExcel() {
		// Convert the selected checkbox IDs into a query parameter
		const queryParams = this.selectedCheckboxIds.join(',');

		// Create the URL with query parameters
		const url = `${DashboardApi.download_excel}?ids=${queryParams}`;

		if ([...queryParams].length === 0) {
			Swal.fire({
				title: i18n.please_select_record_to_download,
				icon: 'info',
			})
		} else {
			window.open(url, '_blank');
		}
	}

	selectAll(event: any) {
		if (event.target.checked) {
			this.pendingInvoices.forEach(key => {
				if (!this.selectedCheckboxIds.includes(key.id)) {
					this.selectedCheckboxIds.push(key.id);
				}
			});
		} else {
			this.selectedCheckboxIds = []
		}
	}

	downloadPDF() {
		// Convert the selected checkbox IDs into a query parameter
		const queryParams = this.selectedCheckboxIds.join(',');

		// Create the URL with query parameters
		const url = `${DashboardApi.download_pdf}?ids=${queryParams}`;

		if ([...queryParams].length === 0) {
			Swal.fire({
				title: i18n.please_select_record_to_download,
				icon: 'info',
			})
		} else {
			window.open(url, '_blank');
		}
	}

	pdfInvoice(uuid: any) {
		(window as any).open(`${environment.baseUrl}/download-invoice/${uuid}/pdf?lang=${(window as any).LOCALE}`, '_blank');
	}

	emailInvoices(selectedInvoices: Array<string>) {
		if (selectedInvoices.length) {
			this.loaderService.startLoading();

			this.invoiceService.action({ 'do': INVOICE_ACTIONS.EMAIL, 'ids': selectedInvoices }).subscribe(data => {
				this.loaderService.stopLoading();

				Swal.fire(i18n.done, i18n.email_sent, 'success');
			}, err => {
				this.loaderService.stopLoading();
				Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
			});
		}
	}

	whatsappInvoices(selectedInvoices: Array<string>) {
		if (selectedInvoices.length) {
			this.loaderService.startLoading();

			this.invoiceService.action({ 'do': INVOICE_ACTIONS.WHATSAPP, 'ids': selectedInvoices }).subscribe(data => {
				this.loaderService.stopLoading();
				Swal.fire(i18n.done, i18n.invoice.whatsapp_message_sent, 'success');
			}, err => {
				this.loaderService.stopLoading();
				Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
			});
		}
	}

	deleteInvoices(selectedInvoices: Array<string>) {
		console.log(selectedInvoices);
		if (selectedInvoices.length) {
		  Swal.fire({
			title: i18n.are_you_sure,
			text: i18n.invoice.you_want_to_delete_invoice,
			icon: 'info',
			showCloseButton: true,
			showCancelButton: true,
			focusConfirm: false,
			confirmButtonText:
			  i18n.yes,
			cancelButtonText:
			  i18n.no_cancel_it
		  }).then(result => {
			if (result.value) {
	
			  this.loaderService.startLoading();
	
			  this.invoiceService.action({ 'do': INVOICE_ACTIONS.DELETE, 'ids': selectedInvoices }).subscribe(data => {
				this.loaderService.stopLoading();
	
				Swal.fire(i18n.deleted, selectedInvoices.length == 1 ? i18n.invoice.invoice_deleted : i18n.invoice.invoices_deleted, 'success');
				this.getPendingInvoices();
			  }, err => {
				this.loaderService.stopLoading();
				Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
			  });
			}
		  });
		}
	}

	orderActions(action, uuid) {
			switch (action) {
				case "edit_invoice":
					this.orderAction.emit({ uuid: uuid, action: action });
					break;
			}
		}
}
